import { Formik } from "formik";
import { Form } from "react-bootstrap";
import MyInput from "src/components/common/FormElements/MyInput";

const MonthSearchForm = ({ initialDate, onSubmit, readOnly }) => {
  return (
    <Formik
      initialValues={{ date: initialDate }}
      enableReinitialize={true}
      onSubmit={async ({ date }) => {
        onSubmit(date);
      }}
    >
      {formik => {
        return (
          <div className="row col-md-5">
            <Form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-3 text-md-end pt-1">年月:</div>
                <div className="col-4">
                  <MyInput
                    label=""
                    name="date"
                    type="month"
                    max="9999-12"
                    placeholder=""
                  />
                </div>
                <div className="col-md-3">
                  <button className="btn btn-primary w-100" type="submit">
                    検索
                  </button>
                </div>
              </div>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default MonthSearchForm;
